import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Patients from "@/pages/Patients";
import PatientDetail from "@/pages/PatientDetail";
import Agenda from "@/pages/Agenda";
import Finance from "@/pages/Finance";
import Tiss from "@/pages/Tiss";
import PatientPortal from "@/pages/PatientPortal";
import Teleconsulta from "@/pages/Teleconsulta";
import LabModule from "@/pages/LabModule";
import Settings from "@/pages/Settings";
import AdminPanel from "@/pages/AdminPanel";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Loader2 className="w-6 h-6 animate-spin text-primary" />
    </div>
  );
}

function Protected({ children, portal = false }) {
  const { user, ready } = useAuth();
  if (!ready) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  const role = user.role;
  if (portal) return role === "paciente" ? children : <Navigate to="/" replace />;
  if (role === "paciente") return <Navigate to="/portal" replace />;
  return children;
}

function App() {
  return (
    <div className="App min-h-screen">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/tele/:room" element={<Teleconsulta />} />
            <Route path="/portal" element={<Protected portal><PatientPortal /></Protected>} />
            <Route path="/" element={<Protected><Layout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="pacientes" element={<Patients />} />
              <Route path="pacientes/:id" element={<PatientDetail />} />
              <Route path="agenda" element={<Agenda />} />
              <Route path="laboratorio" element={<LabModule />} />
              <Route path="financeiro" element={<Finance />} />
              <Route path="convenios" element={<Tiss />} />
              <Route path="configuracoes" element={<Settings />} />
              <Route path="admin" element={<AdminPanel />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
